// common — or. Part of the or i18n bundle; merged by ./index.js

export default {
// Navbar
  home: 'Fuula Dura',
  about: "Waa'ee Keenya",
  contact: 'Nu Quunnamaa',
  signIn: 'Seeni',
  signOut: "Ba'i",
  myDashboard: 'Daashboordii Koo',
  team: 'Garee',
  linksWebsite: 'Marsariitii',
  allCities: '📍 Magaalota Hunda',
  clearFilter: '✕ Haqi',
  noClientsInCity: (city) => `${city} keessatti maamiltoota hin argamne.`,
  verifiedBusinesses: "Daldala mirkana'e hayyama qaban kan beeksifnu",
  verified: "✓ Mirkana'e",
  noClients: 'Ammaaf maamiltoota hin jiran.',
  aboutSub: 'Nuti',
  vision: "Mul'ata",
  mission: 'Ergama',
  visionText: "MSME-oota gargaaruuf Itoophiyaa keessatti dhaabbata maarketiingii dijitaalaa fi beeksisaa duraa ta'uu.",
  missionText: "MSME-oota Itoophiyaa guddina waaraa argachuuf gargaaran furmaata maarketiingii fi beeksisaa haaraa, gatii madaalawaa fi safaramuu danda'u dhiyeessuu.",
  so1: 'Tajaajila maarketiingii ogummaa qabu biyyatti guutuu dhiyeessuu',
  so2: 'Guddina MSME argamummaa dijitaalaa fi braadingiitiin deeggaruu',
  so3: 'Teeknooloojii (marsariitii, app mobaayilii fi miidiyaa hawaasaa) tajaajila dhiyeessuuf fayyadamuu',
  so4: 'Hirmaannaa dheeraa MSME-oota fi dhaabbilee waliin ijaaruu',
  so5: 'Carraa hojii dargaggoota dandeettii qabaniif uumuu',
// Contact,
  contactTitle: 'Nu Quunnamaa',
  contactSub: 'Daldalakee guddisuuf qophii dha?',
  message: 'Ergaa',
  successTitle: 'Ergaan Ergame!',
  successMsg: 'Galatoomaa! Dafnee si quunnamna.',
  sendAnother: 'Biraa Ergi',
  selectType: 'Gosa filadhu...',
  passwordPlaceholder: 'Jecha Darbii *',
  confirmPassword: 'Jecha Darbii Mirkaneessi *',
  minPassword: 'Xiqqaate qubee 6',
  alreadyHave: 'Herrega qabdaa?',
  businessDocsTitle: 'Sanadoota Daldala',
  registrationFailed: "Galmaa'uu hin milkoofne.",
// Login,
  loginTitle: 'Herrega kee seeni',
  loginBtn: 'Seeni',
  loggingIn: 'Seenaa jira...',
  noAccount: 'Herrega hin qabduu?',
  registerBusiness: 'Daldala kee galmeessi',
  loginFailed: 'Seenuu hin milkoofne.',
// Navbar extras,
  blogsNews: 'Blogii/Oduu',
  faq: 'Gaaffiiwwan',
  faqSubtitle: 'All Things, Baazaara fi tajaajila keenyaaf barbaachisa malee hunda waa\'ee keessan fe\'amaa jirtan.',
  faq1q: 'All Things maaliitti?',
  faq1a: 'All Things eejensii maarketiingii dijitaalaa fi faayisa e-commerce Finfinnee, Itoophiyaa keessaatiin uumame jedha. Daldala hayyama qabu Itoophiyaa keessaniif tajaajila maarketiingii fi Baazaara keenya waliin daldala keessaniif guddisuu keessatti isin gargaarna.',
  faq2q: 'Akka gurgurtaatti akkamitti galmaa\'a?',
  faq2a: 'Fuula Quunnamaa gara deemaa sanadoota daldala keessanii, lakkoofsa TIN, hayyama daldala fi galmaa\'uun ELMIS dabalaa ta\'ee unka galchaa. Gareen keenya iyyannoo kee ni madaala.',
  faq3q: 'Baazaarirraa akkamitti bitaa?',
  faq3a: 'Baazaara keessatti oomishaalee ilaali, fooyya\'i kaartiin keetti dabali, itti aansuun kaffaluutti deemi. Jalqabsisuuf herrega bitaa galmaa\'i. Kaffaluu gurgurtaa fi kee gidduu sirriin ta\'uun hojjeta.',
  faq4q: 'Mallaqa kaffaluu gochuun isa jedhu?',
  faq4a: 'Mallaqa kaffaluu gosa gurgurtaa irraan jira. Kenna bakka tokkotti baankii, moobayilii maallaqaa yk cash on delivery Finfinnee keessatti galchu. Daldalaa sanaa mallaqa kaffaluu dhuunfaa filachuuf fuula oomisha ilaali.',
  faq5q: 'Geejjibni akkamitti hojjeta?',
  faq5a: 'Geejjibni bitaan booda gurgurtaa waliin sirriin ta\'uun sirreessa. Gurgurtoonni boqonnaa Finfinnee keessatti geejjiba kennu. Tajaajila chaa fi keenyaan gurgurtaa kee waliin geejjiba haala irra waliin yaadadhu.',
  faq6q: 'Keenyuma deebisuun jira?',
  faq6a: 'Keenyumni kee fi gurgurtaa gidduu hojjeta. Bitaa dura keenyuma gurgurtaa fuula keenya irraan fuula fuulaan erguu isin barbaachisa jedhu.',
  faq7q: 'Akka maamilaa maarketiingii dijitaalaa maaliif ta\'a?',
  faq7a: 'Fuula Quunnamaa yk allthingsethiopia2026@gmail.com irraan nu quunnamaa. Daldala barbaachisee keessan waliin yaadna fi karoorta tooftaa maarketiingii uumna.',
  faq8q: 'All Things tajaajila maala kenna?',
  faq8a: 'Daldala Itoophiyaa maarketiingii dijitaalaa, bulchiinsa gabaa hawaasaa, ijaarsa marsariitii, braandingii, uumuun qabiyyee fi furmaata e-commerce kennina.',
// About extras,
  aboutTag: 'Waa\'ee Keenya',
  aboutHeroTitle1: 'Itoophiyaa',
  aboutHeroTitle2: 'Dijitaalaa Guddina',
  aboutCatalyst: 'Nuti MSME-oota Itoophiyaa gabaa ammayyaa keessatti guddisuuf kan tumsu jedha.',
  whoWeAre: 'Nu Akkamitti',
  whoWeAreText: 'Nuti dijitaalaa maarketiingii fi furmaata e-commerce MSME-oota Itoophiyaa tooftaa daldaa sirrii keessaa irraa guaraa ta\'een guddina tooftaa qabeessa dijitaalaa jijjiiruuf gargaaru. Ergama keenya gatii bakka keessa fi gatii adda addaa gidduu jiru ni cufna.',
  ourCoreValues: 'Gatii',
  ourCoreValuesHighlight: 'Bu\'uuraa',
  strategic: 'Tarsiimoo',
  strategicHighlight: 'Kaayyoo',
// Register extras,
  joinAllThings: 'All Things',
  joinAllThingsHighlight: 'Seenu',
  chooseAccountType: 'Jalqabsisuuf herrega gosa kee filadhu',
  registerYourBusiness: 'Daldala hayyama qaban kee tajaajila ogummaa qabuuf galmeessi.',
  haveAccount: 'Herrega qabdaa?',
  registrationSubmitted: 'Galmaa\'uun Ergame!',
  thankYouName: (name) => `${name} galatoomaa!`,
  thankYouRegistering: 'Herregi kee madaala jira. Gareen keenya daldala kee guyyaa 40 keessatti ni mirkaneessa.',
  goToLogin: 'Gara Seenuutti Deebi\'i',
  selectCity: 'Magaalaa filadhu...',
// Login extras,
  forgot: 'Irraanfatte?',
// Contact info card labels,
  labelEmail: 'Imeelii',
  labelLocation: 'Bakka',
  labelPhone: 'Bilbila',
  labelHours: 'Sa\'aatii',
  labelTelegram: 'Telegraamii',
  labelWhatsApp: 'Watsappii',
  messages: '💬 Ergaawwan',
  noConversations: 'Ammaaf haasawwii hin jiru.',
  selectConversation: 'Haasawwii filadhu jalqabsisuuf',
  typeMessage: 'Ergaa barreessaa...',
  new: 'haaraa',
// Dashboard,
  changePassword: 'Jecha Darbii Jijjiiri',
  copyright: '© 2026 All Things Solution PLC',
// Client detail,
  backToClients: "Gara Maamiltoota Deebi'i",
  established: 'Hundeeffame',
  location: 'Bakka',
  verifiedLicensed: "Daldala Mirkana'e Hayyama Qabu",
  licenseLabel: 'Hayyama',
  clientWorkTitle: 'Hojii Isaaniin',
  ourMarketingWork: 'Hojii Maarketiingii Keenya',
  contactSocial: 'Nu Quunnamaa fi Miidiyaa Hawaasaa',
// Core values,
  cv1Title: 'Haaroomsa fi Uumamummaa',
  cv1Desc: 'Yaada haaraa fi furmaata uumamaa simanna',
  cv2Title: 'Tajaajila Maamilaa Giddugaleessa',
  cv2Desc: "Milkaa'ina maamiltoota keenya hundaaf giddugaleessa",
  cv3Title: 'Amanamummaa fi Iftoominaa',
  cv3Desc: 'Amanamummaa fi iftoominaan hojjenna',
  cv4Title: 'Fudhannaa Teeknooloojii',
  cv4Desc: 'Meeshaalee dijitaalaa haaraa fayyadamna',
  cv5Title: "Raawwii Bu'aa Xiyyeeffate",
  cv5Desc: "Bu'aa safaramuu danda'u irratti xiyyeeffanna",
// Team,
  teamOurPeople: 'Namoota Keenya',
  teamTitle: 'Garee',
  teamTitleHighlight: 'Keenya Beeki',
  teamSubtitle: 'Namoota dandeettii qaban All Things Solution duuba jiran',
// Bazaar,
  filters: 'Naannoo',
  priceRangeEtb: 'Naannoo Kaffaltii (ETB)',
  anyPrice: 'Kaffaltii Kamuu',
  reopensAt: (x) => `Yeroo ${x} sochoa`,
  days: 'Guyyaa',
  hours: 'Waqtii',
  minutes: 'Daqiiqaa',
  seconds: 'Diqaaqaa',
  allClientsLabel: 'Maamiltoota',
  legalTitle: 'Seera ykn Imaammatoota',
  legalTerms: 'Waldaa fi Haalotaa',
  legalPrivacy: 'Imaammata Iccitii Dhuunfaa',
  legalBilling: 'Imaammata Kaffaltii',
  legalCookie: 'Imaammata Kuukii',
  legalCopyright: 'Imaammata Mirga Abbummaa',
  showPassword: 'Jecha iccitii agarsiisi',
  hidePassword: 'Jecha iccitii dhoksi',
  cartTitle: 'Wishlist Kee',
  checkoutTitle: 'Kaffaluu',
  deliveryTitle: 'Geejjiba Gaafadhu',
  addToCart: 'Wishlist Itti Dabaluu',
  added: 'Dabalee',
  proceedToCheckout: 'Gara Kaffaluutti Itti Fufuu',
  placeOrder: "Ajaja Kaa'i",
  addProduct: 'Oomisha Dabaluu',
  editProduct: 'Oomisha Gulaali',
  deleteProduct: 'Oomisha Haqi',
  outOfStock: 'Kuusaan Dhumee',
  selectBank: 'Mala Kaffaluu Filadhu',
  uploadScreenshot: 'Suuraa Galchi',
  enterReference: 'Lakkoofsa Wabii Galchi',
  cartTotal: 'Waliigala',
  linkedOrder: 'Ajaja Filadhu',
  deliveryAddress: 'Teessoo Geejjibaa',
  contactPhone: 'Bilbila Quunnamtii',
  preferredTime: 'Yeroo Geejjibaa Barbaadamu',
  outOfStockError: 'Oomishaaleen tokko tokko kuusaan dhumee.',
  deliveryDuplicateError: 'Gaaffiin geejjibaa ajaja kanaaf duraan jira.',
  backToBazaar: "Gara Baazaaraatti Deebi'i",
  allCategories: 'Gosota Hunda',
  noOrders: 'Ammaaf ajajoota hin jiran.',
// Buyer account,
  registerAsSeller: 'Gurgurtaa Galmaa\'i',
  registerAsBuyer: 'Bitaa Galmaa\'i',
  buyerRegisterTitle: 'Herrega bitaa kee uumi',
  buyerDashboardTitle: 'Seenaa Bitannoo Koo',
  groupedByCategory: 'Gosa Irratti',
  groupedBySeller: 'Gurgurtaa Irratti',
  noPurchases: 'Ammaaf bitannoo hin jiru.',
  instantlyActive: 'Herregni kee hojjechaa jira!',
  ourRoots: 'Bu\'uraa Keenya',
  bridgingTitle: 'Duukkamumsa fi',
  bridgingHighlight: 'Uumamummaa',
  rootsText: 'MSME-oota Itoophiyaa argama dijitaalaa adda addaa keessatti guddisuuf gargaarnu, diinni keenya cunqarfuun. Gabaa ammayyaa irraa gara suuqa dijitaalaatti, guddina keessan waliin hojjenna.',
  ourStory: 'Seenaa Keenya',
  servicesBoost: 'Daldalakee Guddisuuf Dhiyeenna Tajaajila',
  appStore: 'App Suuqi',
  googlePlay: 'Guuglaa Playii',
// Service cards,
  svcSocialMedia: 'Bulchiinsa Miidiyaa Hawaasaa',
  svcSocialMediaDesc: 'Herreega miidiyaa hawaasaa keessanii jalqabsiinsa mirkanaa\'u, hordoftootaa fi tooftaa qabiyyee guutuu dhiyeessa.',
  svcContentCreation: 'Uumuu Qabiyyee',
  svcContentDesc: 'Suuraa, viidiyoo fi graafiiksii ergama daldala kee kennu fi yaadannoo kee furu.',
  svcGrowthStrategy: 'Tarsiimoo Guddina',
  svcGrowthDesc: "Tarsiimoo hojii guddina kee siif deeggarsu fi gatii gabaa kee babal'isuuf.",
  svcPaidAds: 'Beeksisa Kaffalamu',
  svcAdsDesc: 'Beeksisa kaayyoo qabu marsaalee hunda irratti ROI siif guddisu fi maamilaa sirrii siif gahe.',
  svcBranding: 'Braandingii fi LooGo Dizaayinii',
  svcBrandingDesc: 'Maqaa daldala yaadamaa, uumuun loogo fi seenaa suuraa kan gurgurtoota adda baasu.',
  svcOutdoor: 'Beeksisa Ala',
  svcOutdoorDesc: 'Baayiloordii, baaneroota fi furmaata argama ala kee maarketiingii dijitaalaa kee gargaarsisu.',
  svcEcommerce: 'E-Commerce Qindeessuu',
  svcEcomDesc: 'Suuqii bitaa guutuu qindeessuu, tarree oomishaa fi All Things Baazaara irratti mirkana\'insa.',
  svcConsultation: 'Madballa Daldala',
  svcConsultDesc: 'Gargaarsa ogummaa qabu fi tooftaa kee gabaa kee argama dijitaalaatti sirriin ta\'uuf.',
// Clients extras,
  ourPartners: 'Waliigala',
  ourPartnersHighlight: 'Haamataa',
  partnersDesc: 'All Things waliin argama dijitaalaa keessanii guddisuuf daldala haaraa Itoophiyaa ilaali.',
  category: 'Gosa',
  allCategoriesLabel: 'Gosota Hunda',
  city: 'Magaalaa',
// Team extras,
  viewProfile: 'Profaayili Ilaali',
  mpHeroTitle: 'Baazaara',
  mpHeroTitleHighlight: 'Daldalaa hayyama qaban',
  mpHeroDesc: 'Daldala Itoophiyaa amanuu argadhu, meeshaa qulqulluu ijaadhu, baandii keessatti All Things waliin daldala dijitaala kee guddisu.',
  mpStartShopping: 'Ijaadhuuf Biluu',
  mpRegisterBusiness: 'Daldala Kee Galmeessi',
  mpStatBusinesses: 'Daldalaa Hayyama Qaban',
  mpStatProducts: 'Meeshaa Listing Qabame',
  mpStatCities: 'Magaalaa Qabame',
  mpStatSatisfaction: 'Ruxinsuu Cabsuu',
  mpTrustVerified: 'Daldalaa Hayyama Qaban',
  mpTrustSecure: 'Kaffaltii Natiifti',
  mpTrustReturns: 'Deebi\'i Salamuu',
  mpTrust247: 'Gargaarsa 24/7',
  mpTrustVerifiedDesc: 'Daldala hundummaa hayyama qaban ne',
  mpTrustSecureDesc: 'Wajjira barbaachisaa eegnii qabuu',
  mpTrustReturnsDesc: 'Polisii deebi\'i rakkoo hin qabu',
  mpTrust247Desc: 'Yeroo kamiyyatti gargaarra',
  mpCatTitle: 'Ku',
  mpCatTitleHighlight: 'Gosa',
  mpCatDesc: 'Kutaa meeshaa gabaabamee gosa barbaataanii barbaadhu',
  mpPaymentsTitle: 'Kaffaltii Natiifti',
  mpPaymentsTitleHighlight: 'Tarreeffama',
  mpPaymentsDesc: 'Tarreeffama kaffaltii natiifti kanneeffataaf',
  mpTestimonialTitle: 'Maamiltoota Keenya',
  mpTestimonialTitleHighlight: 'Maqaa Waan Jechu',
  mpTestimonialDesc: 'Beekadhu daldalaa All Things keessatti caala qulqulluu taa jedhanii',
  mpNewsletterTitle: 'Akkadhoofadhu Qabduu',
  mpNewsletterDesc: 'Kan biraatiin adeemtu, alaayi haaraa, fi waaree Baazaara akkumaarguu qabsiisuuuf qophaa\'i.',
  mpNewsletterPlaceholder: 'E-mail kee galmaa\'i',
  mpNewsletterBtn: 'Galmaa\'i',
  mpNewsletterSuccess: '✓ Galmaa\'iif galmaa\'uu!',
  mpFooterQuickLinks: 'Linkii Aritii',
};

